import React from 'react'

export const SpakleIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.47972 11.4797L9.02566 6.84186H9.97434L11.5203 11.4797L16.1581 13.0256V13.9743L11.5203 15.5203L9.97434 20.1581H9.02566L7.47972 15.5203L2.84189 13.9743V13.0256L7.47972 11.4797Z" fill="#00BB80"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M16.2297 5.22969L17.0257 2.84186H17.9743L18.7703 5.22969L21.1581 6.02563V6.97431L18.7703 7.77026L17.9743 10.1581H17.0257L16.2297 7.77026L13.8419 6.97431V6.02563L16.2297 5.22969Z" fill="#00BB80"/>
    </svg>
  )
}
